import { render, staticRenderFns } from "./uploadCover.vue?vue&type=template&id=3eb91ef8&scoped=true&"
import script from "./uploadCover.vue?vue&type=script&lang=js&"
export * from "./uploadCover.vue?vue&type=script&lang=js&"
import style0 from "./uploadCover.vue?vue&type=style&index=0&id=3eb91ef8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb91ef8",
  null
  
)

export default component.exports